import React from "react";

const SOCIAL_LINK_KEYS = ["facebook", "instagram", "linkedin", "website", "twitter"];
const LINK_LABELS = {
    facebook: "Facebook",
    instagram: "Instagram",
    linkedin: "LinkedIn",
    website: "Website",
    twitter: "Twitter"
};

const getSocialLinks = (blog) => {
    return SOCIAL_LINK_KEYS.reduce((acc, key) => {
        const value = blog?.socialLinks?.[key] ?? blog?.[key] ?? "";
        if (typeof value === "string") {
            acc[key] = value;
        } else if (value != null) {
            acc[key] = String(value);
        } else {
            acc[key] = "";
        }
        return acc;
    }, {});
};

const SocialLinksModal = ({ blog, onClose }) => {
    const socialLinks = getSocialLinks(blog);
    const hasAnyLink = SOCIAL_LINK_KEYS.some((key) => {
        const link = socialLinks[key];
        return link && link.trim() !== "";
    });

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg w-full max-w-2xl p-6">
                <h2 className="text-xl font-bold mb-4">Social Links</h2>
                <div className="mb-4 space-y-3">
                    {hasAnyLink ? (
                        SOCIAL_LINK_KEYS.map((platform) => {
                            const link = socialLinks[platform];
                            if (!link || link.trim() === "") return null;
                            return (
                                <div key={platform} className="flex items-center gap-3 p-3 border rounded-lg">
                                    <span className="font-medium text-gray-700 min-w-[100px]">
                                        {LINK_LABELS[platform]}:
                                    </span>
                                    <a
                                        href={link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-primary-600 hover:text-primary-800 underline truncate flex-1"
                                    >
                                        {link}
                                    </a>
                                </div>
                            );
                        })
                    ) : (
                        <p className="text-gray-500">No social links available</p>
                    )}
                </div>
                <div className="flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-primary-600 text-white rounded hover:bg-primary-700"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SocialLinksModal;

